import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './matherial/matherial.module';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { PolicyComponent } from './components/footer/policy/policy.component';
import { TermsComponent } from './components/footer/terms/terms.component';
import { BannerCookiesComponent } from './components/banner-cookies/banner-cookies.component';





@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    NavbarComponent,
    ConfirmationModalComponent,
    PolicyComponent,
    TermsComponent,
    BannerCookiesComponent,
  ],
  exports: [
    MaterialModule,
    HeaderComponent,
    FooterComponent,
    NavbarComponent,
    BannerCookiesComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    RouterModule,
    FormsModule,
  ]
})
export class SharedModule { }
